module.exports = __webpack_public_path__ + "media/images/telekom--mobile-45e330e26f6c581d41848863ea90a4b1.svg";